import { css as r } from "../stitches.config.es.js";
const i = r({
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  height: "1.5rem",
  paddingInline: "0.375rem",
  border: "1px solid transparent",
  borderRadius: "0.1875rem",
  whiteSpace: "nowrap",
  variants: {
    variant: {
      pendingFill: {
        color: "$coreGreys150",
        backgroundColor: "$pending50"
      },
      warningFill: {
        color: "$lightBg100Main",
        backgroundColor: "$warning100"
      },
      destructiveFill: {
        color: "$lightBg100Main",
        backgroundColor: "$destructive100main"
      },
      highlight1Fill: {
        color: "$lightBg100Main",
        backgroundColor: "$highlight100"
      },
      highlight2Fill: {
        color: "$lightBg100Main",
        backgroundColor: "$highlightTwo100"
      },
      successFill: {
        color: "$lightBg100Main",
        backgroundColor: "$success100"
      },
      darkFill: {
        color: "$lightBg100Main",
        backgroundColor: "$coreGreys100main"
      },
      pendingOutline: {
        borderRadius: "0.25rem",
        color: "$pending200",
        backgroundColor: "$pending10"
      },
      warningOutline: {
        borderRadius: "0.25rem",
        color: "$warning100",
        backgroundColor: "$warning5"
      },
      destructiveOutline: {
        borderRadius: "0.25rem",
        color: "$destructive200",
        backgroundColor: "$destructive10"
      },
      highlight1Outline: {
        borderRadius: "0.25rem",
        color: "$highlight200",
        backgroundColor: "$highlight10"
      },
      highlight2Outline: {
        borderRadius: "0.25rem",
        color: "$highlightTwo200",
        backgroundColor: "$highlightTwo10"
      },
      successOutline: {
        borderRadius: "0.25rem",
        color: "$success200",
        backgroundColor: "$success10"
      },
      darkOutline: {
        borderRadius: "0.25rem",
        color: "$coreGreys100main",
        backgroundColor: "$secondary10"
      },
      neutralFill: {
        borderRadius: "0.25rem",
        color: "$genericWhite",
        backgroundColor: "$coreGreys70"
      }
    }
  }
});
export {
  i as rootStyles
};
//# sourceMappingURL=TagStatusLight.styles.es.js.map
